<template>
  <es-dialog :title="$t(`兑换优惠券`)" :visible="visible" width="500px" custom-class="coupon-dialog" border
    :before-close="close">
    <div class="content">
      <es-input class="exhcange-no" v-model="couponsNumber" :placeholder="$t(`请输入优惠券码`)"></es-input>
      <es-button class="confirm-exchange" type="primary" @click="checkCouponsNumber" :loading="btnLoading">
        {{ $t('确认兑换') }}
      </es-button>
    </div>
  </es-dialog>
</template>
<script>
export default {
  name: 'ExchangedCoupon',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    confirmExchange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      couponsNumber: '',
      btnLoading: false,
    }
  },
  watch: {
    visible(val) {
      this.btnLoading = false
    },
  },
  methods: {
    close() {
      this.$emit('close', false)
    },
    // 使用优惠券
    async checkCouponsNumber() {
      if (!this.couponsNumber) {
        this.$message.error(this.$t('请输入优惠券码'))

        return
      }
      this.btnLoading = true
      try {
        await this.confirmExchange(this.couponsNumber)
      } finally {
        this.couponsNumber = ''
        this.btnLoading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .coupon-dialog {
  .es-dialog__body {
    padding: 24px 35px;
  }
}

.content {
  display: flex;
  align-items: center;
  padding: 24px 0 56px;
  .confirm-exchange {
    margin-left: 10px;
  }
}
</style>
